import { valueListRoutes } from "./router";
/**
 * Value Lists Module — the admin screen over OPCAT's catalogues. Its nav entry lives in
 * SettingsSidebar (Module management).
 */
export class ValueListsModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[ValueListsModule] Registered");
        return { id: "value-lists", name: "Value Lists Module", version: "1.0.0" };
    }
    getRoutes() {
        return valueListRoutes;
    }
    getNavigationItems() {
        return [];
    }
    getComponent() {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[ValueListsModule] Unregistered");
        this.contracts = null;
    }
}
export default new ValueListsModule();
